import { Dialog as ChakraDialog, Portal } from '@chakra-ui/react';
import { forwardRef } from 'react';

import CloseButton from 'ui/CloseButton';

interface DialogContentProps extends ChakraDialog.ContentProps {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
}

const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
  ({ children, portalled = true, portalRef, ...rest }, ref) => (
    <Portal disabled={!portalled} container={portalRef}>
      <ChakraDialog.Backdrop />
      <ChakraDialog.Positioner zIndex={rest.zIndex}>
        <ChakraDialog.Content ref={ref} asChild={false} h="auto" {...rest}>
          {children}
          <ChakraDialog.CloseTrigger
            position="absolute"
            top="2"
            insetEnd="2"
            asChild
          >
            <CloseButton />
          </ChakraDialog.CloseTrigger>
        </ChakraDialog.Content>
      </ChakraDialog.Positioner>
    </Portal>
  )
);

const DialogHeader = forwardRef<HTMLDivElement, ChakraDialog.HeaderProps>(
  ({ children, ...props }, ref) => (
    <ChakraDialog.Header
      ref={ref}
      bg="green.800"
      color="white"
      fontSize="lg"
      px={4}
      py={3}
      {...props}
    >
      <ChakraDialog.Title>{children}</ChakraDialog.Title>
    </ChakraDialog.Header>
  )
);

const DialogBody = forwardRef<HTMLDivElement, ChakraDialog.BodyProps>(
  ({ children, ...props }, ref) => (
    <ChakraDialog.Body
      ref={ref}
      color="gray.800"
      fontSize="md"
      px={4}
      py={4}
      {...props}
    >
      {children}
    </ChakraDialog.Body>
  )
);

const DialogFooter = forwardRef<HTMLDivElement, ChakraDialog.FooterProps>(
  ({ children, ...props }, ref) => (
    <ChakraDialog.Footer ref={ref} gap={3} px={4} pt={2} pb={4} {...props}>
      {children}
    </ChakraDialog.Footer>
  )
);

const Dialog = {
  Root: ChakraDialog.Root,
  Trigger: ChakraDialog.Trigger,
  Content: DialogContent,
  Header: DialogHeader,
  Body: DialogBody,
  Footer: DialogFooter,
};

export default Dialog;
